// ATO ABN checksum — mirrors pf-api App\Rules\AbnRule.
const WEIGHTS = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]

export function normaliseAbn(value: string): string {
  return value.replace(/\s+/g, '')
}

export function isValidAbn(value: string): boolean {
  const abn = normaliseAbn(value)
  if (!/^\d{11}$/.test(abn)) return false

  const digits = abn.split('').map(Number)
  digits[0] -= 1

  return (
    digits.reduce((sum, digit, i) => sum + digit * WEIGHTS[i], 0) % 89 === 0
  )
}

/** 51824753556 → "51 824 753 556" */
export function formatAbn(value: string | null | undefined): string {
  const abn = normaliseAbn(value ?? '')
  if (abn.length !== 11) return value ?? ''
  return `${abn.slice(0, 2)} ${abn.slice(2, 5)} ${abn.slice(5, 8)} ${abn.slice(8)}`
}
